export default __webpack_public_path__ + "static/media/phoenix.5a9dbf3f.svg";